import type { RouteRecordRaw } from 'vue-router'

const masterRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/layouts/app/layout-app.vue'),
    children: [
      {
        path: 'pengguna',
        children: [
          {
            path: '',
            name: 'user list',
            component: () => import('@/views/master/user/list/page-list.vue'),
          },
          {
            path: 'tambah',
            name: 'user create',
            component: () => import('@/views/master/user/page-user-create.vue'),
          },
          {
            path: ':id',
            name: 'user detail',
            props: true,
            component: () => import('@/views/master/user/detail/page-detail.vue'),
          },
          {
            path: ':id/bank',
            name: 'user edit bank',
            props: true,
            component: () => import('@/views/master/user/page-user-edit-bank.vue'),
          },
        ],
      },
      {
        path: 'peran',
        name: 'role list',
        component: () => import('@/views/master/role/page-list.vue'),
      },
      {
        path: 'produk',
        children: [
          {
            path: '',
            name: 'product list',
            component: () => import('@/views/master/product/list/page-list.vue'),
          },
          {
            path: ':id',
            name: 'product detail',
            component: () => import('@/views/master/product/detail/page-product-detail.vue'),
          },
          {
            path: 'tambah',
            name: 'product add',
            component: () => import('@/views/master/product/page-product-create.vue'),
          },
        ],
      },
      {
        path: 'kategori-produk',
        children: [
          {
            path: '',
            name: 'category list',
            component: () => import('@/views/master/product-category/list/page-list.vue'),
          },
          {
            path: ':id',
            name: 'category product detail',
            props: true,
            component: () => import('@/views/master/product-category/detail/page-product-category-detail.vue'),
          },
        ],
      },
      {
        path: 'supplier',
        children: [
          {
            path: '',
            name: 'supplier list',
            component: () => import('@/views/master/supplier/list/page-list.vue'),
          },
          {
            path: 'tambah',
            name: 'supplier add',
            component: () => import('@/views/master/supplier/page-supplier-create.vue'),
          },
          {
            path: ':id',
            name: 'supplier detail',
            props: true,
            component: () => import('@/views/master/supplier/detail/page-supplier-detail.vue'),
          },
        ],
      },
      {
        path: 'metode-pembayaran',
        children: [
          {
            path: '',
            name: 'payment method list',
            component: () => import('@/views/master/payment-method/list/page-list.vue'),
          },
          {
            path: ':id',
            name: 'payment method detail',
            component: () => import('@/views/master/payment-method/detail/page-payment-method-detail.vue'),
          },

        ],
      },
      {
        path: 'pemotongan-gaji',
        name: 'employee salary deduction list',
        component: () => import('@/views/master/employee-salary-deduction/page-list.vue'),
      },
      {
        path: 'pengumuman',
        children: [
          {
            path: '',
            name: 'announcement list',
            component: () => import('@/views/announcement/page-announcement-list.vue'),
          },
          {
            path: 'tambah',
            name: 'announcement create',
            component: () => import('@/views/announcement/page-announcement-create.vue'),
          },
          {
            path: ':id/edit',
            name: 'announcement edit',
            props: true,
            component: () => import('@/views/announcement/page-announcement-edit.vue'),
          },
        ],
      },
      {
        path: 'pengaturan-sistem',
        children: [
          {
            path: '',
            name: 'system setting',
            component: () => import('@/views/master/system-setting/page-system-setting.vue'),
          },
          {
            path: 'audit',
            name: 'audit log',
            component: () => import('@/views/master/audit/page-list.vue'),
          },
        ],
      },
    ],
  },
]

export { masterRoutes }
